<template>
  <g>
    <path
      class="fill-none"
      d="M11.9871 18.003C13.4371 18.003 14.6121 19.178 14.6121 20.628C14.6121 22.078 13.4371 23.253 11.9871 23.253C10.5371 23.253 9.36206 22.078 9.36206 20.628C9.36206 19.178 10.5371 18.003 11.9871 18.003Z"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="fill-none"
      d="M11.9871 0.752991C13.4371 0.752991 14.6121 1.92799 14.6121 3.37799C14.6121 4.82799 13.4371 6.00299 11.9871 6.00299C10.5371 6.00299 9.36206 4.82799 9.36206 3.37799C9.36206 1.92799 10.5371 0.752991 11.9871 0.752991Z"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="fill-none"
      d="M11.9871 9.37799C13.4371 9.37799 14.6121 10.553 14.6121 12.003C14.6121 13.453 13.4371 14.628 11.9871 14.628C10.5371 14.628 9.36206 13.453 9.36206 12.003C9.36206 10.553 10.5371 9.37799 11.9871 9.37799Z"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconMore",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>